var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('j-markdown',{staticClass:"article-body",attrs:{"source":_vm.article.get('body'),"images":_vm.article.images,"embeds":_vm.article.embeds}})}
var staticRenderFns = []

export { render, staticRenderFns }